import { useEffect, useMemo, useRef } from "react";
import useScript from "../../../hooks/useScript";
import styles from "./index.module.scss";

export default function Twitter({ id }: { id: string }): JSX.Element {
  useScript("https://platform.twitter.com/widgets.js");

  const tweetRef = useRef(null);
  const tweetHref = useMemo(() => `https://twitter.com/user/status/${id}`, [id]);

  useEffect(() => {
    if (window.twttr && tweetRef.current) {
      window.twttr.ready().then(() => {
        window.twttr.widgets.createTweetEmbed(id, tweetRef.current);
      });
    }
  }, [tweetRef]);

  return (
    <blockquote className={["twitter-tweet", styles["twitter-embed"]].join(" ")} ref={tweetRef}>
      <a href={tweetHref} target="_blank" rel="nofollow">
        {tweetHref}
      </a>
    </blockquote>
  );
}
